export interface FileLinks {
        self: {
        href: string;
    };
        files: {
        href: string;
    };
        product: {
        href: string;
    };
        exhibitor: {
        href: string;
    };
        catalogue: {
        href: string;
    };
}
    
export interface File {
    id: number;
    creationTime: string;
    createdBy: string;
    lastModifiedBy: string;
    url: string;
    _links: FileLinks;
}

/**
 * Utility function to remove the file extension from a URL.
 * @param url - The URL of the file.
 * @returns The URL without the file extension.
 */
export function removeExtFromUrlFile(url: string): string {
    if(url != null) {
      const fileName = url.split('/');
      return removeExt(fileName[fileName.length - 1]);
    } else {
      return "";
    }
  }

  function removeExt(fileName:string):string {
    if(fileName.match(/\./)) {
        var splitted = fileName.split(".");
        splitted.pop();
        return splitted.join(".");
    }
    return fileName;
  }